import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'

import { cn } from '../../utils'

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackColor?: string;
    rangeColor?: string;
    thumbStyling?: string;
    iconComponent?: React.ReactNode;
    size?: 'small' | 'large';
  }
>(
  (
    {
      className,
      trackColor = 'bg-[#F5F5F5]',
      rangeColor = 'bg-[#303030]',
      thumbStyling,
      iconComponent,
      size = 'large',
      ...props
    },
    ref
  ) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          'relative h-2 w-full grow overflow-hidden rounded-full',
          size === 'small' ? 'h-1' : 'h-2',
          trackColor
        )}
      >
        <SliderPrimitive.Range className={cn('absolute h-full', rangeColor)} />
        {props.step && props.max && (
          <div className='absolute flex justify-between items-center w-full h-full px-1'>
            {[...Array(props.max / props.step + 1)].map((_, index) => (
              <div key={index} className='h-1 w-1 rounded-full bg-[#D4D4D4]' />
            ))}
          </div>
        )}
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          'block rounded-full border-2 border-[#303030] bg-[#FCFBFD] focus:outline-none focus:shadow-ds-default disabled:pointer-events-none disabled:opacity-50 cursor-pointer',
          size === 'small' ? 'h-4 w-4' : 'h-5 w-5',
          thumbStyling
        )}
      >
        {iconComponent}
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  )
)
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
